export default "__VITE_ASSET__B0oM135t__"